import { useNavigationLocalData } from 'component/Navigation/hooks/useNavigationLocalData'
import { INTERNAL_TYPE_GAME, INTERNAL_TYPE_NAV, LINK_TYPE_INTERNAL } from 'constant/advertisement'
import { useSelector } from 'react-redux'
import { selectNavigationContent } from 'redux/selector/app'
import { useCallback } from 'react'
import { useAppNavigate } from 'app-layered-layout/useAppNavigate'
import { useAppLocationQuery } from 'app-layered-layout/useAppLocationQuery'
import { URL_QUERY_DISABLE_LAYOUT } from 'constant/routes'
import { useOpenGamePopup } from './useOpenGamePopup'
import { selectGameUserStatus } from 'redux/selector/game'
import { formatDate } from 'utils/timeFormat'
import { fetchPostAdEvent } from 'api'
import { useGameBanCheck } from './useGameBanCheck'
import { useIpBanCheck } from './useIpBanCheck'
import { SchemaOholoMaterialShow } from 'api/generated'
import { GAME } from 'constant/routers'

const getPopStateEvent = (): Promise<void> => {
  return new Promise((resolve) => {
    const handler = (_ev: PopStateEvent) => {
      resolve()
      window.removeEventListener('popstate', handler)
    }

    window.addEventListener('popstate', handler)
  })
}

interface DataItemLink {
  link: SchemaOholoMaterialShow
  pageUuid?: string
}

export const useAdLinkHandler = () => {
  const navigationContent = useSelector(selectNavigationContent)
  const navigate = useAppNavigate()
  const localData = useNavigationLocalData()
  const query = useAppLocationQuery()
  const isPopup = query[URL_QUERY_DISABLE_LAYOUT] != null
  const openGamePopup = useOpenGamePopup()
  const gameUserStatus = useSelector(selectGameUserStatus)
  const { validateUser } = useGameBanCheck(gameUserStatus)
  const { validateIpBan } = useIpBanCheck()

  return useCallback(
    ({
      link: {
        link_type,
        internal_type,
        internal_id,
        link,
        game_platform,
        game_type_id,
        direction,
        id,
        name,
        site_type,
        oholoer_id,
        oholoer_link,
        oholoer_name,
      },
    }: DataItemLink) => {
      fetchPostAdEvent({
        date: formatDate(new Date()),
        material_id: id,
        material_name: name,
        oholo_site_id: site_type,
        oholoer_id,
        oholoer_link,
        oholoer_name,
      })
      if (link_type !== LINK_TYPE_INTERNAL) {
        if (link !== '') {
          window.open(link, '_blank')
        }
      } else {
        const gameId = internal_id
        switch (internal_type) {
          case INTERNAL_TYPE_GAME:
            validateIpBan(() => {
              validateUser(() => {
                openGamePopup({
                  id: gameId,
                  ...(game_platform
                    ? {
                        gameType: game_type_id,
                        tpCode: game_platform,
                        direction: direction,
                      }
                    : {}),
                })
              })
            })
            break
          case INTERNAL_TYPE_NAV:
          default:
            const index = navigationContent.findIndex((i: any) => i.id === internal_id)

            if (index < 0) {
              return
            }

            const target = localData.navContent[index]

            const toPage = () => {
              if (isPopup) {
                const popState = getPopStateEvent()
                navigate(-1)
                popState.then(() => {
                  navigate(target.navLink + target.search, { replace: true, forceReplaceNonCurrentPage: true })
                })
              } else {
                navigate(target.navLink + target.search, { replace: true, forceReplaceNonCurrentPage: true })
              }
            }

            if (target.navLink === GAME) {
              validateIpBan(() => {
                toPage()
              })
            } else {
              toPage()
            }
        }
      }
    },
    [isPopup, localData.navContent, navigate, navigationContent, openGamePopup, validateIpBan, validateUser]
  )
}
